// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.downloads {
  padding: 30px;
}
.downloads h3 {
  color: #3fb9ea;
  font-size: 24px;
  margin-bottom: 20px;
}
.downloads a {
  text-decoration: none !important;
  color: inherit;
}
.downloads a .downloadsCard {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 20px;
  margin: 10px;
  transition: all 0.3s ease;
}
.downloads a .downloadsCard:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
  transition: all 0.3s ease;
}
.downloads a .downloadsCard:hover .animateSpan .fas {
  transform: translateX(400%);
  transition: transform 0.3s ease;
}
.downloads a .downloadsCard:hover .animateSpan span {
  opacity: 0;
  transition: opacity 0.3s ease;
}
.downloads a .downloadsCard .date {
  font-size: 14px;
  color: #808080;
  margin-bottom: 10px;
}
.downloads a .downloadsCard .name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.downloads a .downloadsCard .animateSpan {
  text-align: right;
}
.downloads a .downloadsCard .animateSpan .fas {
  font-size: 20px;
  color: #d60000;
}
.downloads a .downloadsCard .animateSpan span {
  font-weight: bold;
  color: #3fb9ea;
  opacity: 1;
}

.row {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Defaults/Footer/Downloads/Style.scss"],"names":[],"mappings":"AAMA;EACE,aAAA;AALF;AAOE;EACE,cATM;EAUN,eAAA;EACA,mBAAA;AALJ;AAQE;EACE,gCAAA;EACA,cAAA;AANJ;AAQI;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AANN;AAQM;EACE,wCAAA;EACA,2BAAA;EACA,yBAAA;AANR;AASU;EACE,2BAAA;EACA,+BAAA;AAPZ;AASU;EACE,UAAA;EACA,6BAAA;AAPZ;AAYM;EACE,eAAA;EACA,cAzCD;EA0CC,mBAAA;AAVR;AAaM;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAXR;AAcM;EACE,iBAAA;AAZR;AAcQ;EACE,eAAA;EACA,cA1DE;AA8CZ;AAeQ;EACE,iBAAA;EACA,cAhEA;EAiEA,UAAA;AAbV;;AAoBA;EACE,aAAA;EACA,uBAAA;AAjBF","sourcesContent":["// Color Variables\r\n$primary: #3fb9ea;\r\n$secondary: #d60000;\r\n$hover: #b80000;\r\n$gray: #808080;\r\n\r\n.downloads {\r\n  padding: 30px;\r\n\r\n  h3 {\r\n    color: $primary;\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  a {\r\n    text-decoration: none !important;\r\n    color: inherit;\r\n\r\n    .downloadsCard {\r\n      border: 1px solid #eee;\r\n      border-radius: 8px;\r\n      padding: 20px;\r\n      margin: 10px;\r\n      transition: all 0.3s ease;\r\n\r\n      &:hover {\r\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n        transform: translateY(-5px);\r\n        transition: all 0.3s ease;\r\n\r\n        .animateSpan {\r\n          .fas {\r\n            transform: translateX(400%); // Moves the icon to the right\r\n            transition: transform 0.3s ease;\r\n          }\r\n          span {\r\n            opacity: 0;\r\n            transition: opacity 0.3s ease;\r\n          }\r\n        }\r\n      }\r\n\r\n      .date {\r\n        font-size: 14px;\r\n        color: $gray;\r\n        margin-bottom: 10px;\r\n      }\r\n\r\n      .name {\r\n        font-size: 18px;\r\n        font-weight: bold;\r\n        margin-bottom: 10px;\r\n      }\r\n\r\n      .animateSpan {\r\n        text-align: right;\r\n\r\n        .fas {\r\n          font-size: 20px;\r\n          color: $secondary;\r\n        }\r\n\r\n        span {\r\n          font-weight: bold;\r\n          color: $primary;\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
